import type { TourConfig } from '../../types/tour.types'

// ICP Setup list. Anchors are `data-tour` attributes on the view (added alongside this tour).
// Teaches context first, controls last.
const icpTour: TourConfig = {
  id: 'icp',
  title: 'Define your ideal customer',
  module: 'Prospecting',
  routeName: 'IcpList',
  order: 11,
  autoStart: true,
  steps: [
    {
      id: 'intro',
      title: 'Describe who you want to sell to',
      body: 'An **Ideal Customer Profile (ICP)** is the set of criteria — industry, size, location, technologies and more — that describes your best-fit customer. TAMI uses it to **find** matching companies and to **score** lists you upload.',
    },
    {
      id: 'create',
      target: '[data-tour="icp-create"]',
      placement: 'bottom',
      title: 'Build a new ICP',
      body: 'Create a profile by choosing criteria across **industry, business size, location, technologies, e-commerce and service providers**. The tighter the criteria, the sharper your matches and scores.',
    },
    {
      id: 'table',
      target: '[data-tour="icp-table"]',
      placement: 'top',
      title: 'Manage and rank your ICPs',
      body: 'Your profiles live here. **Drag to rank them** by priority, edit or delete, or **run a search** to instantly find companies that match — straight into the List Builder.',
    },
    {
      id: 'scoring',
      target: '[data-tour="icp-scoring"]',
      placement: 'bottom',
      title: 'Put your ICP to work',
      body: 'ICPs also power **Lead Scoring** — jump to your scoring lists to grade uploaded companies against these profiles and work the best-fit leads first.',
    },
  ],
}

export default icpTour
